export const colors = {
  error: {
    base: '#e53e3e',
    light: '#FFE8E8',
    mid: '#FFC1C1',
    dark: '#CC3232',
  },
  text: {
    base: '#241E24',
    secondary: '#918991',
    alt: '#C3C1C3',
  },
  grey: {
    base: '#918991',
    dark: '#746c74',
  },
  cancel: {
    base: '#918991',
    dark: '#817981',
  },
  brand: {
    primary: {
      base: '#06BCC1',
      dark: '#03A2A7',
      opaque: '#E2F5F5',
      disabled: '#5DD9DD',
    },
    secondary: {
      base: '#FF6666',
      dark: '#db4242',
    }
  }
};
